import React, { useEffect, useMemo } from "react";
import isArray from "lodash/isArray";
import { useForm } from "./hooks/useForm";
export const FormFieldArray = ({ name, resetOnUnmount, children }) => {
    const { getValue, getField, push, remove, state, addField, removeField, store } = useForm();
    let fieldArray = getValue(name);
    if (fieldArray === null || fieldArray === undefined || !isArray(fieldArray)) {
        fieldArray = [];
    }
    let child = useMemo(() => {
        return children({
            fields: fieldArray.map((f, index) => `${name}[${index}]`),
            push: value => push(name, value),
            remove: (index) => remove(name, index),
            form: store
        });
    }, [fieldArray.length, name]);
    useEffect(() => {
        const field = getField(name);
        if (!field) {
            addField({ path: name });
        }
        return () => {
            removeField(name, resetOnUnmount);
        };
    }, []);
    return React.createElement(React.Fragment, null, child);
};
//# sourceMappingURL=FormFieldArray.js.map